'use strict';

module.exports = function(Chart) {

	Chart.Line = function(context, config) {
		config.type = 'line';

		return new Chart(context, config);
	};

};



//////////////////
// WEBPACK FOOTER
// ./~/chart.js/src/charts/Chart.Line.js
// module id = 1547
// module chunks = 1